export const SIDEBAR_ID = {
	CONNECT: 'CONNECT',
	CORE: 'CORE',
	FILTERS: 'FILTERS',
	FILTERS_GLOBAL: 'FILTERS_GLOBAL',
	FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
	GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
	GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
	GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
	GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
	GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
	JSM: 'JSM',
	JSW_CLASSIC: 'JSW_CLASSIC',
	JSW_NEXT_GEN: 'JSW_NEXT_GEN',
	PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
	EOC_OPERATIONS: 'EOC_OPERATIONS',
	POLARIS: 'POLARIS',
	USER: 'USER',
	HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
} as const;
